
const digest = 'd6971232685796ba60755acc718612ae57f36cf4c468d5370e99582ad92a2b89';
const classes = {"controls":"_controls_nn2f9_1","button":"_button_nn2f9_8"};
const css = `._controls_nn2f9_1 {
  display: flex;
  flex-direction: row;
  gap: 15px;
  align-items: center;
  margin-top: 35px;
}
._controls_nn2f9_1 ._button_nn2f9_8 {
  width: fit-content;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  